import React from 'react';
import { Outlet } from 'react-router';
import { ChatNotificationProvider } from './ChatNotificationProvider';
import { ChatNotificationStack } from './ChatNotificationStack';

/**
 * Router 의 parent route element — 모든 자식 route 가 이 안에서 렌더된다.
 * 위치는 RouterProvider 하위라 useLocation/useNavigate 가 정상 동작.
 */
export const ChatNotificationLayout: React.FC = () => {
    return (
        <ChatNotificationProvider>
            <Outlet />
            <ChatNotificationStack />
        </ChatNotificationProvider>
    );
};
